import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Case } from "../../cases/_types/case";


export enum MailRecipientType {
    To = "To",
    Cc = "Cc",
    Bcc = "Bcc"
}

export enum MailMessageRecipientState {
    Pending = "Pending",
    Error = "Error",
    Sent = "Sent"
}

export class MailMessageRecipient extends Resource {
    public override type = 'mailMessageRecipients';

    @prop()
    public mailMessageId!: string;

    @prop()
    public name!: string;

    @prop()
    public entityType!: string;

    @prop()
    public entityId!: string;

    @prop()
    public recipientType:  number = 0;
    //public recipientType: MailRecipientType = MailRecipientType.To;
    
    @prop()
    public mailAddress: string = "";

    @prop()
    public state:  number = 0;
    //public state: MailMessageRecipientState = MailMessageRecipientState.Pending;

    @prop()
    public stateDate: Date = new Date();
}